import { useEffect } from 'react';
import { useSessionContext } from '@supabase/auth-helpers-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to manage admin access control for RidePulse admin console.
 * Only allows authenticated users in the canonical admin allowlist
 * (admin@ridepulse.app and support@ridepulse.app).
 * Automatically redirects unauthorized users to /login page.
 * Server enforcement via is_web_admin() remains authoritative.
 */
export const useAdminAccess = () => {
  const { session, isLoading: sessionLoading } = useSessionContext();
  const { isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  const userEmail = session?.user?.email || null;
  const isAuthorized = isAuthenticated;
  const isLoading = sessionLoading || authLoading;

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthorized) {
      navigate('/login');
    }
  }, [session, isAuthorized, isLoading, navigate, userEmail]);

  return { isAuthorized, isLoading, userEmail };
};
